import { createTransform } from 'redux-persist';
import moment from 'moment';

/**
 * transforms moment objects to ISO strings
 * @param {any} obj - The object to transform
 * @returns {any} - The transformed object
 */
function transformMomentToString(obj) {
  if (moment.isMoment(obj)) {
    return {
      isMomentObject: true,
      value: obj.toISOString(),
    };
  }

  if (Array.isArray(obj)) {
    return obj.map(transformMomentToString);
  }

  if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      acc[key] = transformMomentToString(obj[key]);
      return acc;
    }, {});
  }

  return obj;
}

/**
 * Transforms ISO strings back to moment objects
 * @param {any} obj - The object to transform
 * @returns {any} - The transformed object
 */
function transformStringToMoment(obj) {
  if (obj && typeof obj === 'object' && obj.isMomentObject) {
    return moment(obj.value);
  }

  if (Array.isArray(obj)) {
    return obj.map(transformStringToMoment);
  }

  if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      acc[key] = transformStringToMoment(obj[key]);
      return acc;
    }, {});
  }

  return obj;
}

/**
 * Transform to handle moment objects in Redux Persist
 * Converts moment objects to ISO strings when storing and back to moment objects when rehydrating
 */
const momentTransform = createTransform(
  // Transform state on its way to being serialized and persisted
  (inboundState) => {
    return transformMomentToString(inboundState);
  },
  // Transform state being rehydrated
  (outboundState) => {
    return transformStringToMoment(outboundState);
  }
);

export default momentTransform;
